import type { TOC } from '@ember/component/template-only'
import { PageHeader } from 'teacher-ui-client/components/page-header'
import { t } from 'ember-intl'
import { TilesPdfEntry } from 'teacher-ui-client/components/tiles/pdf-entry'
import RouteTemplate from 'ember-route-template'
import type FastPhonicsQuickLinksController from 'teacher-ui-client/subscription-type/quick-links/fast-phonics/controller'

interface Signature {
  Args: {
    controller: FastPhonicsQuickLinksController
  }
}
export const QuickLinksFastPhonicsPage: TOC<Signature> = <template>
  <div class="w-full">
    <PageHeader>
      <:title>
        <h1>
          {{t "quickLinks.pageTitles.fastPhonics"}}
        </h1>
      </:title>
    </PageHeader>

    <div class="safari-gap-6 mx-auto flex max-w-(--breakpoint-lg) flex-wrap items-stretch justify-center gap-6 p-6">
      {{#each @controller.fastPhonicsEntries as |entry|}}
        <TilesPdfEntry
          @productFormatted={{t "products.fp"}}
          @title={{entry.title}}
          @pdfUrl={{entry.fileUrl}}
          @image={{entry.coverUrl}}
          @description={{entry.description}}
        />
      {{/each}}
    </div>
  </div>
</template>

export default RouteTemplate(QuickLinksFastPhonicsPage)
